import { render, staticRenderFns } from "./OffloadReport.vue?vue&type=template&id=8f25c244&scoped=true&"
import script from "./OffloadReport.vue?vue&type=script&lang=js&"
export * from "./OffloadReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f25c244",
  null
  
)

export default component.exports